import React from 'react';
import { View, StyleSheet } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../../constants';
import AttractionsDetailViewCommon from './AttractionsDetailViewCommon';
/**
 * AttracionsDetailsViewWeb Component
 * 
 * This component renders the details of an event specifically for a web environment using react-native-web.
 * It displays the name, date, time, and location of an attraction, making use of the DetailCommon component for the UI.
 * 
 * Props:
 *  - route: Contains parameters passed through the navigation stack, including the event details.
 * 
 * @file AttracionsDetailsViewWeb.js
 * @module AttracionsDetailsViewWeb
 */
const AttracionsDetailsViewWeb = ({ route }) => {
    return (
        <View style={styles.container}>
            <AttractionsDetailViewCommon
                route={route}
                FontAwesomeIcon={FontAwesomeIcon}
                iconSize='lg'
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.textLight,
        padding: 16,
    },
});

export default AttracionsDetailsViewWeb;
